import React, { useEffect, useState } from "react";
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./textEditor.css";
import { Field, useField } from "formik";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from 'html-to-draftjs';

const TextEditor = (props) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error;
  const { initialValues, onChange } = props;
  const { answer } = props.initialValues;


  useEffect(() => {
    if (answer) {
      const blocksFromHTML = htmlToDraft(answer);
      const { contentBlocks, entityMap } = blocksFromHTML;
      const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      setEditorState(EditorState.createWithContent(contentState));
    } else {
      setEditorState(EditorState.createEmpty());
    }
  }, [answer]);


  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
    const convertedToHTML = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
    if (convertedToHTML == "<p></p>\n") {
      onChange && onChange("");
    } else {
      onChange && onChange(convertedToHTML);
    }
  };

  return (
    <>
      <div className={`input_wrapper ${hasError ? "input_wrapper has_error" : ""}	${props.customclass} `}>
        {props.label && (
          <label
            style={{ color: props.labelColor }}
            className="label"
            htmlFor={props.name}
          >
            {props.label}
          </label>
        )}
        <Field name={props.name}>
          {({ field, form: { setFieldValue } }) => (
            <Editor
              editorState={editorState}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="editorClassName"
              onEditorStateChange={onEditorStateChange}
              toolbar={{
                options: ["inline", "textAlign", "list", "link"],
                inline: {
                  options: ["bold", "italic", "underline"],
                },
                textAlign: {
                  options: ["left", "center", "right"],
                },
                list: {
                  options: ["unordered", "ordered"],
                },
                link: {
                  options: ["link"],
                },
              }}
              placeholder={props.placeholder}
            />
          )}
        </Field>
        {hasError ? (
          <div className="error__text">{props.customError || meta.error}</div>
        ) : null}
      </div>
    </>
  );
};

export default TextEditor;
